export default "__VITE_ASSET__BBBbJtcr__"